// extracted by mini-css-extract-plugin
export default {"list":"ResultSections_list__CLKlF"};